import React, { memo } from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock, Zap, Globe, Check } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
const BASE_URL = 'https://kit-online-2026.myshopify.com/cart/44581699879047:1';
const PREMIUM_URL = 'https://kit-online-2026.myshopify.com/cart/44581703417991:1';
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-4 py-8 px-4 bg-brand-cream" data-id="element-151">
      <div className="max-w-6xl mx-auto" data-id="element-152">
        <div className="text-center mb-6" data-id="element-153">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-navy uppercase leading-tight" data-id="element-154">
            Elegí el plan que{' '}
            <span className="green-highlight" data-id="element-155">mejor se adapta a vos:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-156">
          {/* BASE */}
          <div className="brunson-card rounded-xl p-5 md:p-7 flex flex-col relative" data-id="element-157">
            <div className="text-center mb-3" data-id="element-158">
              <p className="text-brand-green font-display font-bold uppercase text-xs tracking-widest" data-id="element-159">
                ✅ Opción Base
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-brand-navy uppercase leading-tight mt-1" data-id="element-160">
                Sistema Acuicultura Pro™
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-161">
                Todo lo que necesitás para transformar tus clases desde el
                primer día
              </p>
            </div>

            <ul className="space-y-2 mb-4 flex-grow" data-id="element-162">
              {['6 Tomos Maestros (500+ páginas)', 'Bono 1 — 50 Actividades Listas', 'Bono 2 — Evaluaciones y Rúbricas', 'Bono 3 — Proyectos Prácticos', 'Bono 4 — Planificación Anual Editable', 'Actualizaciones de por vida'].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-163">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-green shrink-0 mt-0.5" strokeWidth={3} data-id="element-164" />
                  <span className="text-sm md:text-base text-brand-ink font-medium" data-id="element-165">
                    {f}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-creamAlt rounded-lg p-3 text-center mb-4 border border-brand-line" data-id="element-166">
              <p className="text-xs text-brand-mute font-bold uppercase" data-id="element-167">
                Valor total: <span className="line-through" data-id="element-168">USD 265</span>
              </p>
              <p className="font-display text-4xl md:text-5xl font-bold text-brand-orange leading-none mt-1" data-id="element-169">
                🔥 USD 19,90
              </p>
              <p className="text-[11px] text-brand-mute font-medium mt-1" data-id="element-170">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <Button href={BASE_URL} data-id="element-171">
              🚀 Sí, Quiero el Sistema Acuicultura Pro
            </Button>
            <Trust data-id="element-172" />
          </div>

          {/* PREMIUM */}
          <div className="bg-white rounded-xl p-5 md:p-7 flex flex-col relative border-[3px] border-brand-green shadow-[0_8px_0_#1A365D,0_12px_32px_rgba(26,54,93,0.22)]" data-id="element-173">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white font-display font-bold text-xs md:text-sm tracking-widest px-4 py-1.5 rounded-full uppercase border-2 border-white whitespace-nowrap shadow-md" data-id="element-174">
              🏅 Elección de los Expertos
            </div>

            <div className="text-center mb-3 mt-2" data-id="element-175">
              <p className="text-brand-green font-display font-bold uppercase text-xs tracking-widest" data-id="element-176">
                ⭐ Pack Premium
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-brand-navy uppercase leading-tight mt-1" data-id="element-177">
                Sistema + Mega Banco Acuícola Pro
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-178">
                Para el docente que quiere ir más lejos que el resto
              </p>
            </div>

            <p className="text-xs md:text-sm text-brand-ink font-bold mb-2 uppercase tracking-wide" data-id="element-179">
              Todo lo anterior, más 💎 Mega Banco Acuícola Pro:
            </p>
            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-180">
              {[{
              t: 'Simulaciones de Crisis:',
              d: 'Resolución de problemas reales bajo presión.'
            }, {
              t: 'Dossiers industriales:',
              d: 'Gestión técnica basada en datos de granjas.'
            }, {
              t: '100 Preguntas Élite:',
              d: 'Razonamiento experto (cero memoria).'
            }, {
              t: 'Desafíos Extremos:',
              d: 'Soluciones creativas a límites biológicos y de presupuesto.'
            }, {
              t: 'Dinámicas Pro:',
              d: 'Cumbres de negociación, casos reales y proyectos de élite.'
            }].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-181">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-green shrink-0 mt-0.5" strokeWidth={3} data-id="element-182" />
                  <span className="text-sm md:text-base text-brand-ink leading-snug" data-id="element-183">
                    <span className="font-bold" data-id="element-184">{f.t}</span> {f.d}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-greenSoft rounded-lg p-3 text-center mb-4 border border-brand-green" data-id="element-185">
              <p className="text-xs text-brand-mute font-bold uppercase" data-id="element-186">
                Valor total: <span className="line-through" data-id="element-187">USD 562</span>
              </p>
              <p className="font-display text-4xl md:text-5xl font-bold text-brand-orange leading-none mt-1" data-id="element-188">
                🔥 USD 23,90
              </p>
              <p className="text-[11px] text-brand-navy font-bold mt-1" data-id="element-189">
                Solo USD 4 más que la opción base
              </p>
            </div>

            <Button href={PREMIUM_URL} data-id="element-190">
              🚀 Sí, Quiero el Pack Premium + Mega Banco Pro
            </Button>
            <Trust data-id="element-191" />
          </div>
        </div>

        <p className="text-center text-[11px] md:text-xs text-brand-mute font-medium mt-5 max-w-3xl mx-auto leading-snug" data-id="element-192">
          El precio está expresado en dólares estadounidenses (USD). El cobro se
          realiza automáticamente en la moneda de tu país al tipo de cambio del
          momento de la compra.
        </p>
      </div>
    </section>;
}
function Trust() {
  return <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-3 text-[10px] md:text-xs font-bold text-brand-navy uppercase tracking-wide" data-id="element-193">
      <div className="flex items-center" data-id="element-194">
        <Lock className="w-3 h-3 mr-1 text-brand-green" data-id="element-195" /> Pago seguro
      </div>
      <div className="flex items-center" data-id="element-196">
        <Zap className="w-3 h-3 mr-1 text-brand-green" data-id="element-197" /> Acceso 5 min
      </div>
      <div className="flex items-center" data-id="element-198">
        <Globe className="w-3 h-3 mr-1 text-brand-green" data-id="element-199" /> En tu moneda
      </div>
      <div className="flex items-center" data-id="element-200">
        <ShieldCheck className="w-3 h-3 mr-1 text-brand-green" data-id="element-201" /> Garantía 7
        días
      </div>
    </div>;
}